<template>
  <div class="container">
    <div class="row">
      <div class="overviewAndNav mb-1">
        <h3>Overzicht afwezigheden {{ this.currentlySelectedMonth | toMonthNameWithYear }}</h3>

        <div class="col-lg-3 text-right">
          <button class="btn-basic btn-dark mr-2"
              style="width: 50px;"
              @click="previousMonth">
            <svg
                class="bi bi-chevron-left" fill="currentColor"
                height="1em" viewBox="0 0 16 16"
                width="1em" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                  fill-rule="evenodd"/>
            </svg>
          </button>
          <button class="btn-basic btn-dark"
              style="width: 50px;"
              @click="nextMonth">
            <svg
                class="bi bi-chevron-right" fill="currentColor"
                height="1em" viewBox="0 0 16 16"
                width="1em" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                  fill-rule="evenodd"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
          <tr>
            <SortableTableHeaderComponent
                columnName="dayInMonth" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Datum"/>
            <SortableTableHeaderComponent
                columnName="userId" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Gebruiker id"/>
            <SortableTableHeaderComponent
                columnName="firstName" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Voornaam"/>
            <SortableTableHeaderComponent
                columnName="lastName" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Achternaam"/>
            <SortableTableHeaderComponent
                columnName="absenceUserReadableFormat" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Beschrijving"/>
          </tr>
          </thead>
          <template v-for="(userAbsence, index) in sortedUserAbsences">
            <tr :key="index">
              <td>{{ dayToDate(userAbsence.dayInMonth) }}</td>
              <td>{{ userAbsence.userId }}</td>
              <td>{{ userAbsence.firstName }}</td>
              <td>{{ userAbsence.lastName }}</td>
              <td>{{ userAbsence.absenceUserReadableFormat }}</td>
            </tr>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import moment from "moment";
import FilterModes, {AbsenceTypeList} from "@/constants/FilterConstants";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";
import {toYearAndMonthAndDay} from "@/util/DateUtil";

export default {
  name: "AdminAbsencesViewComponent",
  components: {SortableTableHeaderComponent},
  data: () => ({
    userFiltering: FilterModes.ALL,
    currentSortColumn: "dayInMonth",
    currentSortDirectionAscending: true,
  }),
  computed: {
    ...mapGetters({
      userAbsences: 'administrationUser/userAbsences',
      currentlySelectedMonth: "time/currentlySelectedMonth"
    }),
    sortedUserAbsences: function () {
      if (this.currentSortColumn === "absenceType") {
        return sortListByColumnAndDirection(this.filterUserAbsences(), this.currentSortColumn, this.currentSortDirectionAscending, this.getAbsenceTypeText);
      }
      return sortListByColumnAndDirection(this.filterUserAbsences(), this.currentSortColumn, this.currentSortDirectionAscending);
    },
  },
  async created() {
    await this.fetchUserAbsences();
  },
  methods: {
    ...mapActions("administrationUser", ["fetchUserAbsences"]),
    ...mapMutations({
      addMonth: "time/addMonth",
      subtractMonth: "time/subtractMonth"
    }),
    previousMonth() {
      this.subtractMonth();
      this.fetchUserAbsences();
    },
    nextMonth() {
      this.addMonth();
      this.fetchUserAbsences();
    },
    dayToDate(day) {
      const date = moment(this.currentlySelectedMonth);
      date.date(day);
      return toYearAndMonthAndDay(date);
    },
    getFilterModes() {
      return AbsenceTypeList;
    },
    getAbsenceTypeText(custom) {
      return custom ? FilterModes.CUSTOM : FilterModes.NOT_CUSTOM;
    },
    filterUserAbsences() {
      if (this.userFiltering === FilterModes.CUSTOM) {
        return this.userAbsences.filter(userAbsence => this.isCustom(userAbsence.absenceType));
      }
      if (this.userFiltering === FilterModes.NOT_CUSTOM) {
        return this.userAbsences.filter(userAbsence => !this.isCustom(userAbsence.absenceType));
      }
      return this.userAbsences;
    },
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    }
  },

};
</script>

<style scoped>

.overviewAndNav {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

td {
  vertical-align: middle;
}

</style>
